<div
  *ngIf="companies.length"
  (scroll)="onScroll($event)"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header">
  <table
    mat-table
    [dataSource]="companies"
    class="sp-width__full">
    <ng-container matColumnDef="company_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'COMPANIES.ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <app-shared-id
          [content]="company.company_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="business_name">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.BUSINESS_NAME_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <span
          *ngIf="company.business_name"
          class="sp-color__primary sp-text__ellipsized sp-text__bold">
          {{
            company.business_name?.length > 30
              ? (company.business_name | slice : 0 : 30) + '...'
              : company.business_name
          }}
        </span>
        <span *ngIf="!company.business_name"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.STATUS_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <div class="sp-row__align">
          <div
            class="sp-circle__xs sp-margin__right"
            [matTooltip]="getCompanyStatusLabel(company) | translate"
            [ngClass]="getCompanyStatusBackgroundClass(company)"></div>
          <h5 class="sp-color__primary sp-text__ellipsized">{{ getCompanyStatusLabel(company) | translate }}</h5>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'COMPANIES.REGISTRATION_DATE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <span class="sp-color__primary sp-text__ellipsized"> {{ company.created_at | date : 'short' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="owner_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized"> {{ 'ORDERS.OWNER_COLUMN_LABEL' | translate }} ID </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <app-shared-id
          [content]="company.owner_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="owner_email">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized"> {{ 'ORDERS.OWNER_COLUMN_LABEL' | translate }} email </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <span class="sp-color__primary sp-text__ellipsized"> {{ company.owner_email || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="vat">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.VAT_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <span class="sp-color__primary sp-text__ellipsized"> {{ company.vat || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="sales_network_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'COMPANIES.SALES_NETWORK_ID_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <div class="sp-row__center">
          <span class="sp-color__primary sp-text__ellipsized sp-text__right">
            {{ company.sales_network_id || '-' }}
          </span>
          <button
            mat-icon-button
            [disabled]="!isSalesNetworkIDEditable(company)"
            (click)="onSetSalesNetworkIdClick(company); $event.stopPropagation()">
            <mat-icon [color]="isSalesNetworkIDEditable(company) ? 'accent' : ''"> create </mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="product_category">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'COMPANIES.PRODUCT_CATEGORY' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <div class="sp-row__center">
          <span class="sp-color__primary sp-text__ellipsized sp-text__right">
            {{ getCompanyProductCategoryLabel(company) | translate }}
          </span>
          <button
            mat-icon-button
            (click)="onSetProductCategoryClick(company); $event.stopPropagation()">
            <mat-icon color="accent"> create </mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="agreement">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.AGREEMENT_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <div class="sp-row__center">
          <span class="sp-color__primary sp-text__ellipsized sp-text__right">
            {{ company.agreement ?? '-' }}
          </span>
          <button
            mat-icon-button
            (click)="onSetAgreementClick(company); $event.stopPropagation()">
            <mat-icon color="accent"> create </mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="revenues">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.REVENUES_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <span class="sp-color__primary sp-text__ellipsized"> {{ getRevenuesRange(company) || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="website">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.WEBSITE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <span class="sp-color__primary sp-text__ellipsized"> {{ company.website || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="cms">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'COMPANIES.CMS_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <span class="sp-color__primary sp-text__ellipsized"> {{ company.cms || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="origin">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized"> {{ 'COMPANIES.ORIGIN_LABEL' | translate }} </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <span class="sp-color__primary sp-text__ellipsized"> {{ company.origin || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="sales_reference_email">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'COMPANIES.SALES_REFERENCE_EMAIL_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <div class="sp-row__center">
          <span class="sp-color__primary sp-text__ellipsized sp-text__right">
            {{ company.sales_reference_email || '-' }}
          </span>
          <button
            mat-icon-button
            (click)="onSetSalesReferenceEmailClick(company); $event.stopPropagation()">
            <mat-icon color="accent"> create </mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="custom_subdomain">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized"> Custom subdomain </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <span class="sp-color__primary sp-text__ellipsized"> {{ company.custom_buyer_subdomain || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.ACTIONS_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <div class="sp-row__align">
          <button
            mat-icon-button
            class="sp-icon__button sp-icon__button-dark sp-margin__left"
            [matTooltip]="'GENERAL.SEE_DETAILS_CTA' | translate">
            <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
          </button>
          <button
            mat-icon-button
            [matMenuTriggerFor]="actionsMenu"
            (click)="$event.stopPropagation()"
            class="sp-icon__button sp-icon__button-accent sp-margin__left">
            <mat-icon class="material-symbols-outlined">more_horiz</mat-icon>
          </button>
          <mat-menu #actionsMenu="matMenu">
            <button
              mat-menu-item
              (click)="onContractClick(company)">
              <mat-icon class="material-symbols-outlined">description</mat-icon>
              <span>{{ 'COMPANIES.CONTRACTS_VIEW_CTA' | translate }}</span>
            </button>

            <button
              mat-menu-item
              (click)="onArchiveClick(company)">
              <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
              <span>{{ 'COMPANIES.ARCHIVE_CTA' | translate }}</span>
            </button>

            <button
              mat-menu-item
              (click)="onPaymentMethodsClick(company)">
              <mat-icon class="material-symbols-outlined">account_balance</mat-icon>
              <span>{{ 'STORES.PAYMENT_METHODS_LABEL' | translate }}</span>
            </button>

            <button
              (click)="onEnableDisableClick(company)"
              mat-menu-item>
              <mat-icon class="material-symbols-outlined"> do_not_disturb_on </mat-icon>
              <span>{{ 'COMPANIES.ENABLE_DISABLE_CTA' | translate }}</span>
            </button>

            <button
              mat-menu-item
              (click)="onAllowedStepsClick(company)">
              <mat-icon class="material-symbols-outlined">apps</mat-icon>
              <span>{{ 'STORES.ALLOWED_STEPS_LABEL' | translate }}</span>
            </button>
            <button
              mat-menu-item
              (click)="onTicketClick(company)">
              <mat-icon class="material-symbols-outlined">euro</mat-icon>
              <span>{{ 'STORES.TICKET_CTA' | translate }}</span>
            </button>
            <button
              mat-menu-item
              (click)="onEditClick(company)">
              <mat-icon class="material-symbols-outlined">create</mat-icon>
              <span>{{ 'COMPANIES.EDIT_CTA' | translate }}</span>
            </button>
            <button
              mat-menu-item
              (click)="onSettingsClick(company)">
              <mat-icon class="material-symbols-outlined">settings</mat-icon>
              <span>{{ 'STORES.SETTINGS_LABEL' | translate }}</span>
            </button>
            <button
              mat-menu-item
              (click)="onSetCustomDomainClick(company)">
              <mat-icon class="material-symbols-outlined sp-icon__min-width">public</mat-icon>
              <span>{{ 'STORES.CUSTOM_BUYER_SUBDOMAIN_LABEL' | translate }}</span>
            </button>
          </mat-menu>
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr
      mat-row
      class="sp-cursor__pointer"
      *matRowDef="let row; columns: displayed_columns"
      (click)="onDetailsClick(row)"></tr>
  </table>
</div>
